import calculateProductPriceByDays from './calculateProductPriceByDays'
export default calculateProductPriceByDays
